import { render, staticRenderFns } from "./ProductCustomerView.vue?vue&type=template&id=68236870&scoped=true"
import script from "./ProductCustomerView.vue?vue&type=script&lang=js"
export * from "./ProductCustomerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68236870",
  null
  
)

export default component.exports